import { render, staticRenderFns } from "./BulkAddAssigneesModal.vue?vue&type=template&id=084cac10"
import script from "./BulkAddAssigneesModal.vue?vue&type=script&lang=js"
export * from "./BulkAddAssigneesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports